import { authGet } from './authMiddleware';

export const getPeopleAutocomplete = async (query) => {
    return authGet(`api/People/AutoComplete?PeopleName=${query}`);
}